import React from "react";
import { IonModal } from "@ionic/react";
import styled from "styled-components";

import { getProjectConfig } from "../../projects";
import { useConfig } from "../../contexts/ConfigContext";

type Props = {
  isOpen: boolean;
  onDismiss: () => void;
};

const AboutModal: React.FC<Props> = ({ isOpen, onDismiss }) => {
  const { app } = useConfig();
  // Per-study "Qui sommes-nous ?" content; undefined = minimal generic modal.
  const about = getProjectConfig().about;

  return (
    <IonModal
      className="resonance-sheetmodal"
      isOpen={isOpen}
      onDidDismiss={onDismiss}
      breakpoints={[0, 1]}
      initialBreakpoint={1}
    >
      <Container>
        <Header>
          <Title>{about?.title ?? app?.name ?? ""}</Title>
          <CloseButton onClick={onDismiss}>×</CloseButton>
        </Header>

        {/* TEXTE */}
        {about?.paragraphs.map((paragraph, i) => (
          <Text key={i}>{paragraph}</Text>
        ))}

        {/* 🔝 LOGOS */}
        {about && about.logosTop.length > 0 && (
          <LogosGrid>
            {about.logosTop.map((src, i) => (
              <Logo key={i} src={src} />
            ))}
          </LogosGrid>
        )}

        {/* 🔽 PARTENAIRES */}
        {about && about.logosBottom.length > 0 && (
          <>
            <PartnersTitle>Nos partenaires</PartnersTitle>
            <LogosRow>
              {about.logosBottom.map((src, i) => (
                <Logo key={i} src={src} />
              ))}
            </LogosRow>
          </>
        )}
      </Container>
    </IonModal>
  );
};

export default AboutModal;



const Container = styled.div`
  padding: 20px;
  background: var(--app-color-background, #ffffff);
  min-height: 100%;
`;

const Header = styled.div`
  display: flex;
  justify-content: space-between;
  align-items: center;
`;

const Title = styled.h1`
  font-size: 1.6rem;
  margin: 0;
  color: var(--app-color-text, #041723);
`;

const CloseButton = styled.button`
  width: 40px;
  height: 40px;
  border: none;
  border-radius: 50%;
  background: var(--app-color-surface-tint, white);
  color: var(--app-color-text, #041723);
  font-size: 1.5rem;
  cursor: pointer;
`;

const Text = styled.p`
  margin: 16px 0;
  font-size: 1rem;
  line-height: 1.7;
  color: rgba(var(--app-color-text-rgb, 4, 23, 35), 0.7);
`;

/* 🔝 logos */

const LogosGrid = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  justify-items: center;
  gap: 10px;
  margin-top: 10px;

  @media (min-width: 600px) {
    grid-template-columns: repeat(4, 1fr);
  }
`;



const LogosRow = styled.div`
  display: flex;
  justify-content: center;
  align-items: center;
  gap: 24px;
  margin-top: 10px;
  flex-wrap: wrap;
`;

const PartnersTitle = styled.h2`
  font-size: 1.3rem;
  margin: 14px 0 10px;
  text-align: center;
  color: var(--app-color-text, #041723);
`;



const Logo = styled.img`
  height: 55px;
  width: auto;
  object-fit: contain;

  opacity: 0.9;
  transition: 0.2s;

  &:hover {
    opacity: 1;
    transform: scale(1.05);
  }
`;
